import React from 'react'

const Chatbox = () => {
  return (
    <div>Chatbox</div>
  )
}

export default Chatbox